const preloadedChunks = new Set();

const safeImport = (key, loader) => {
  if (preloadedChunks.has(key)) return;
  preloadedChunks.add(key);
  loader().catch(() => {
    preloadedChunks.delete(key);
  });
};

const normalize = (path = "") => {
  const noHash = String(path).split("#")[0];
  const noQuery = noHash.split("?")[0];
  if (!noQuery) return "/";
  return noQuery.endsWith("/") && noQuery !== "/" ? noQuery.slice(0, -1) : noQuery;
};

export const prefetchRouteByPath = (path) => {
  if (typeof window === "undefined") return;

  const cleanPath = normalize(path);

  if (cleanPath === "/" || cleanPath === "/home") {
    safeImport("home", () => import("../pages/Home"));
    return;
  }

  if (cleanPath.startsWith("/schools")) {
    safeImport("schools-directory", () => import("../pages/schools/SchoolsDirectory"));
    safeImport("school-details", () => import("../pages/schools/AndhraSchoolDetails"));
    safeImport("school-top-picks", () => import("../pages/schools/SchoolTopPicks"));
    return;
  }

  if (cleanPath.startsWith("/intermediate")) {
    safeImport("intermediate-list", () => import("../pages/Intermediate/IntermediateColleges"));
    safeImport("intermediate-detail", () => import("../pages/Intermediate/CollegeDetails"));
    safeImport("intermediate-district", () => import("../pages/Intermediate/DistrictLandingHub"));
    safeImport("intermediate-stream", () => import("../pages/Intermediate/DistrictStreamLanding"));
    return;
  }

  if (cleanPath.startsWith("/colleges/btech")) {
    safeImport("btech-list", () => import("../pages/colleges/BTech"));
    safeImport("btech-district", () => import("../pages/colleges/BtechDistrictWise"));
    safeImport("btech-detail", () => import("../pages/colleges/BtechCollegeDetails"));
    return;
  }

  if (cleanPath.startsWith("/engineering-syllabus")) {
    safeImport("engineering-syllabus", () => import("../pages/JntuhSyllabus"));
    return;
  }

  if (cleanPath.startsWith("/engineering-important-questions")) {
    safeImport("engineering-qa-water", () => import("../pages/JntuhWaterTreatmentQuestions"));
    safeImport("engineering-qa-matrices", () => import("../pages/JntuhMatricesQuestions"));
    return;
  }

  if (cleanPath.startsWith("/colleges/degree")) {
    safeImport("degree-list", () => import("../pages/colleges/CollegesDegree"));
    safeImport("degree-detail", () => import("../pages/colleges/DegreeCollegeDetails"));
    return;
  }

  if (cleanPath.startsWith("/eamcet")) {
    safeImport("eamcet", () => import("../pages/Eamcet"));
    safeImport("eamcet-results", () => import("../pages/results/EamcetResults"));
    return;
  }

  if (cleanPath.startsWith("/results")) {
    safeImport("results-home", () => import("../pages/results/Results"));
    safeImport("results-ssc", () => import("../pages/results/SscResults"));
    safeImport("results-inter", () => import("../pages/results/IntermediateResults"));
    return;
  }

  if (cleanPath.startsWith("/guides") || cleanPath.startsWith("/faq")) {
    safeImport("guides-index", () => import("../pages/content/KnowledgeIndex"));
    safeImport("guides-page", () => import("../pages/content/KnowledgePage"));
    return;
  }

  if (cleanPath.startsWith("/contact-us")) {
    safeImport("contact", () => import("../components/ContactUsPage"));
    return;
  }

  if (cleanPath.startsWith("/advertise-with-us")) {
    safeImport("advertise", () => import("../pages/AdvertiseWithUs"));
    return;
  }
};

export default prefetchRouteByPath;
